export default {
  en: {
    deleted_body: 'Message was deleted.',
    file_sent: 'A file was sent',
    my_last_message_label: 'You',
    new: 'New',
    unsent_messages_note: 'Some messages are not sent.',
  },
};
